<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8 mx-auto">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0 font-weight-bold">平台設置</p>
              <button
                class="btn btn-primary btn-sm ms-auto"
                @click="saveSettings"
                v-if="can('system.settings')"
              >
                儲存變更
              </button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">一般資訊</p>
            <div class="row">
              <div class="col-md-6">
                <label for="site-name" class="form-control-label"
                  >平台名稱</label
                >
                <input
                  id="site-name"
                  class="form-control"
                  type="text"
                  v-model="settings.site_name"
                />
              </div>
              <div class="col-md-6">
                <label for="support-email" class="form-control-label"
                  >支援電子郵件</label
                >
                <input
                  id="support-email"
                  class="form-control"
                  type="email"
                  v-model="settings.support_email"
                />
              </div>
            </div>
            <hr class="horizontal dark" />
            <p class="text-uppercase text-sm">費用與佣金</p>
            <div class="row">
              <div class="col-md-6">
                <label for="commission-rate" class="form-control-label"
                  >平台佣金 (%)</label
                >
                <input
                  id="commission-rate"
                  class="form-control"
                  type="number"
                  v-model="settings.commission_rate"
                  step="0.1"
                />
                <small class="text-muted">每筆銷售收取的百分比。</small>
              </div>
              <div class="col-md-6">
                <label for="certification-fee" class="form-control-label"
                  >認證費用 (NT$)</label
                >
                <input
                  id="certification-fee"
                  class="form-control"
                  type="number"
                  v-model="settings.certification_fee"
                />
                <small class="text-muted">產品認證收取的費用。</small>
              </div>
            </div>
            <hr class="horizontal dark" />
            <p class="text-uppercase text-sm">運費</p>
            <div class="row">
              <div class="col-md-4">
                <label for="shipping-fee-taiwan" class="form-control-label"
                  >台灣運費 (NT$)</label
                >
                <input
                  id="shipping-fee-taiwan"
                  class="form-control"
                  type="number"
                  v-model="settings.shipping_fee_taiwan"
                />
                <small class="text-muted">台灣本杰配送費用。</small>
              </div>
              <div class="col-md-4">
                <label for="shipping-fee-foreign" class="form-control-label"
                  >海外運費 (NT$)</label
                >
                <input
                  id="shipping-fee-foreign"
                  class="form-control"
                  type="number"
                  v-model="settings.shipping_fee_foreign"
                />
                <small class="text-muted">海外地區配送費用。</small>
              </div>
              <div class="col-md-4">
                <label for="free-shipping-threshold" class="form-control-label"
                  >免運門檻 (NT$)</label
                >
                <input
                  id="free-shipping-threshold"
                  class="form-control"
                  type="number"
                  v-model="settings.free_shipping_threshold"
                />
                <small class="text-muted">訂單滿額免運。</small>
              </div>
            </div>
            <hr class="horizontal dark" />
            <p class="text-uppercase text-sm">PayUni 物流設定</p>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-control-label">商店代號 (Merchant ID)</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="settings.payuni_merchant_id"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-control-label">環境 (Environment)</label>
                <select
                  class="form-control"
                  v-model="settings.payuni_environment"
                >
                  <option value="sandbox">測試環境 (Sandbox)</option>
                  <option value="production">正式環境 (Production)</option>
                </select>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-control-label">Hash Key</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="settings.payuni_hash_key"
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-control-label">Hash IV</label>
                <input
                  class="form-control"
                  type="text"
                  v-model="settings.payuni_hash_iv"
                />
              </div>
            </div>
            <hr class="horizontal dark" />
            <hr class="horizontal dark" />
            <p class="text-uppercase text-sm">LINE 設定 (Messaging API)</p>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-control-label"
                  >Channel Access Token (Long-lived)</label
                >
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="settings.line_channel_access_token"
                  placeholder="請輸入 LINE Channel Access Token"
                ></textarea>
              </div>
            </div>
            <hr class="horizontal dark" />
            <p class="text-uppercase text-sm">外觀設置 (Storefront Theme)</p>
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-control-label">主要顏色 (Primary)</label>
                <div class="d-flex align-items-center">
                  <input
                    type="color"
                    class="form-control form-control-color me-2"
                    v-model="settings.theme_color_primary"
                    title="Choose your color"
                  />
                  <input
                    type="text"
                    class="form-control"
                    v-model="settings.theme_color_primary"
                  />
                </div>
                <small class="text-muted">文字、主要按鈕背景</small>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-control-label">次要顏色 (Secondary)</label>
                <div class="d-flex align-items-center">
                  <input
                    type="color"
                    class="form-control form-control-color me-2"
                    v-model="settings.theme_color_secondary"
                    title="Choose your color"
                  />
                  <input
                    type="text"
                    class="form-control"
                    v-model="settings.theme_color_secondary"
                  />
                </div>
                <small class="text-muted">背景色、按鈕文字</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-control-label"
                  >強調色 - 淺色 (Accent Light)</label
                >
                <div class="d-flex align-items-center">
                  <input
                    type="color"
                    class="form-control form-control-color me-2"
                    v-model="settings.theme_color_accent_light"
                    title="Choose your color"
                  />
                  <input
                    type="text"
                    class="form-control"
                    v-model="settings.theme_color_accent_light"
                  />
                </div>
                <small class="text-muted">背景區塊</small>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-control-label"
                  >強調色 - 金色 (Accent Gold)</label
                >
                <div class="d-flex align-items-center">
                  <input
                    type="color"
                    class="form-control form-control-color me-2"
                    v-model="settings.theme_color_accent_gold"
                    title="Choose your color"
                  />
                  <input
                    type="text"
                    class="form-control"
                    v-model="settings.theme_color_accent_gold"
                  />
                </div>
                <small class="text-muted">高亮元素、價格、圖標</small>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-control-label"
                  >強調色 - 暖灰 (Accent Warm)</label
                >
                <div class="d-flex align-items-center">
                  <input
                    type="color"
                    class="form-control form-control-color me-2"
                    v-model="settings.theme_color_accent_warm"
                    title="Choose your color"
                  />
                  <input
                    type="text"
                    class="form-control"
                    v-model="settings.theme_color_accent_warm"
                  />
                </div>
                <small class="text-muted">次要文字、邊框</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import { hasPermission } from "@/utils/permissions";

export default {
  name: "Settings",
  data() {
    return {
      settings: {
        site_name: "Goldshop",
        support_email: "support@goldshop.com",
        commission_rate: 10,
        certification_fee: 500,
        shipping_fee_taiwan: 100,
        shipping_fee_foreign: 300,
        free_shipping_threshold: 5000,
        // Theme Settings
        theme_color_primary: "#1A1A1A",
        theme_color_secondary: "#FFFFFF",
        theme_color_accent_light: "#F4F4F5",
        theme_color_accent_gold: "#C5A572",
        theme_color_accent_warm: "#8C8C8C",
        product_policy_text: "",
        // PayUni
        payuni_merchant_id: "",
        payuni_hash_key: "",
        payuni_hash_iv: "",
        payuni_environment: "sandbox",

        // LINE Settings
        line_channel_access_token: "",
        line_channel_secret: "",
      },
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchSettings() {
      try {
        const response = await request.get("/api/admin/site-settings");
        if (Array.isArray(response.data.data)) {
          response.data.data.forEach((setting) => {
            // Check if key exists in settings (legacy) OR if it starts with theme_color_
            if (
              Object.prototype.hasOwnProperty.call(this.settings, setting.key)
            ) {
              this.settings[setting.key] = setting.value;
            } else if (setting.key.startsWith("theme_color_")) {
              // Dynamically add theme keys to data if not already present (though we initialized them)
              this.settings[setting.key] = setting.value;
            }
          });
        }
      } catch (error) {
        console.error("Failed to fetch settings", error);
      }
    },
    async saveSettings() {
      try {
        // Transform settings object to array of { key, value } for batch update
        const settingsArray = Object.keys(this.settings).map((key) => ({
          key: key,
          value: this.settings[key],
        }));

        await request.post("/api/admin/site-settings/batch", {
          settings: settingsArray,
        });
        Swal.fire("成功", "設置儲存成功", "success");
      } catch (error) {
        console.error("Failed to save settings", error);
        Swal.fire("錯誤", "儲存設置失敗", "error");
      }
    },
  },
  created() {
    this.fetchSettings();
  },
};
</script>
